import { BaseRouteRpc, RoleType } from '../../../../../core';
import { OrdersAllowedStoresFindAllForAdminByUserRequestSchema } from './request';
import { OrdersAllowedStoresFindAllForAdminByUserResponseSchema } from './response';
  
/**
* @description
*
*
* Request interface:
* ```
* export interface OrdersAllowedStoresFindAllForAdminByUserRequestSchema extends ContractData {
*     userId: string;
* }
*
* ```
* Response interface:
*
* ```
* export interface OrdersAllowedStoresFindAllForAdminByUserResponseSchema extends ContractData {
*     stores: Store[];
* }
*
* export interface Store {
*     id:              number;
*     marketplace?:    Marketplace;
*     source:          Source;
*     storeId:         number;
*     storeName:       string;
*     userId:          string;
*     ordersTotal:     number;
*     paidOrdersTotal: number;
* }
*
* export type Marketplace = "etsy" | "shipstation" | "amazon" | "ebay" | "shopify" | "walmart";
*
* export type Source = "etsy" | "shipstation" | "manual" | "shipstation-root";
*
* ```
*/
export class OrdersAllowedStoresFindAllForAdminByUserRouteRpc extends BaseRouteRpc {
  static method = 'orders-allowed-stores-find-all-for-admin-by-user';

  static request: OrdersAllowedStoresFindAllForAdminByUserRequestSchema;
  static response: OrdersAllowedStoresFindAllForAdminByUserResponseSchema;

  static role = RoleType.admin;
}
